interface Output {
    provider?: string;
    containerType?: string;
    containerId?: string;
    mediaId?: string;
}

/** Parse Media docId */
export function parseDocId(docId: string): Output {
    try {
        const docIdStr = atob(docId);
        const entries = docIdStr
            .split('/')
            .map((part) => part.split('='))
            .filter(([key, value]) => key && value);
        return Object.fromEntries(entries) as Output;
    } catch (e) {
        return {};
    }
}
